import { AfterViewInit, Component, ElementRef, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GoogleMapsService } from './services/google-maps.service';
import { isPlatformBrowser } from '@angular/common';
import { TranslationService } from './services/translation.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit , AfterViewInit{
  title = 'landing-page';
  @ViewChild('mapContainer', { static: false }) mapContainer!: ElementRef;

  constructor(
    private googleMapsService: GoogleMapsService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private translationService: TranslationService,
    
    private translate: TranslateService
  ) {
    // Initialize translations only on the client side
    if (isPlatformBrowser(this.platformId)) {
    // Add supported languages
    this.translate.addLangs(['en', 'fr', 'ar']);
    
    // Set default language
    this.translate.setDefaultLang('en');
    
    // Try to get language from localStorage
    const savedLang = localStorage.getItem('preferred_lang');

    
    
    if (savedLang && this.translate.getLangs().includes(savedLang)) {
      // Use saved language if it's valid
      this.translate.use(savedLang);
      document.documentElement.dir = savedLang === 'ar' ? 'rtl' : 'ltr';
    } else {
      // Get browser language (first two characters to match language codes)
      const browserLang = this.translate.getBrowserLang()?.split('-')[0];
      
      // Use browser language if supported, otherwise use default
      const langToUse = browserLang?.match(/en|fr|ar/) ? browserLang : 'en';
      this.translate.use(langToUse);
      document.documentElement.dir = langToUse === 'ar' ? 'rtl' : 'ltr';
      
      // Save the language preference
      localStorage.setItem('preferred_lang', langToUse);

      
    }   
    // this.uploadMetaBalise();
  
  }
  }

  async ngOnInit() {

    // if (this.mapContainer) {
    //   this.googleMapsService.loadMapIfVisible(this.mapContainer.nativeElement);
    // }
  }

  ngAfterViewInit() {
    // Lazy-load Google Maps seulement si le conteneur de la carte est visible
    if (this.mapContainer) {
    }
  }


  switchLanguage(lang: string) {
    this.translationService.changeLanguage(lang);
  }



}

